var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fontLoaded && _vm.status)?_c('v-text',{ref:"txtRef",attrs:{"config":Object.assign({}, _vm.configText, {offset: _vm.offset, verticalAlign: 'middle'}, _vm.gradient)}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d3ad38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Artwork/Text.vue
// module id = 339
// module chunks = 0